/* This is the only file a partner needs to edit for a new artwork or setting. */
(function(){
  const files=window.VIULET_ASSETS;
  const abs=path=>new URL(path,document.baseURI).href;
  const resolve=item=>({...item,src:abs(item.src||item.path)});
  const frames=Object.fromEntries(Object.entries(files.frames).map(([name,item])=>[name,resolve(item)]));
  const mats=Object.fromEntries(Object.entries(files.mats).map(([name,item])=>[name,resolve(item)]));
  const details=Object.fromEntries(Object.entries(files.details).map(([name,item])=>[name,resolve(item)]));
  const previewPricing={base:111,framed:111,premiumFinish:111,currency:'USD'};
  window.VIULET_GALLERY_CONFIG={
    artwork:{
      id:'the-strawberry',title:'The Strawberry',artist:'Benjamin Viulet',
      ...resolve(files.artwork.display),src:window.StrawberryArtwork,
      detail:{...resolve(files.artwork.detail),src:window.StrawberryArtwork},
      dimensions:[20,30,40],defaultSelection:{size:30,presentation:'Crowned',finish:'Nocturne Black',mat:'Cream'}
    },
    assets:{
      frames,mats,
      details,
      backgrounds:{
        gallery:{name:'Gallery',color:'#f1eee6',artCenterY:.48,scaleFieldWidthIn:50,
          lighting:{castOpacity:.68,contactOpacity:.39,castBlur:1.05,castX:.72,castY:1.14,unframedStrength:1.24,unframedLift:1.20,recessStrength:1.8,printShadowStrength:2.1},
          focusLayouts:{20:{fieldWidthIn:38},30:{fieldWidthIn:44},40:{fieldWidthIn:49}}},
        room:{name:'Sunlit room',src:abs(window.ViuletJourneyAsset("assets/room-one-restored.webp")),color:'#f1eee6',artCenterY:.375,
          video:{src:abs(window.ViuletJourneyAsset("assets/sunlight-loop.mp4")),width:1440,height:1440,type:'video/mp4'},
          // Off-camera daylight on the left agrees with this room's down-right cast shadows.
          surfaceReflection:{type:'soft-window',opacity:.085,highlightOpacity:.11,offsetXIn:2},
          sceneFit:'contain',cameraCoupled:true,cameraFieldWidthIn:68,sourceAnchorX:.5,sourceAnchorY:.375,scaleFieldWidthIn:68,focusFieldWidthIn:64,
          lighting:{castOpacity:.56,contactOpacity:.35,castBlur:1.2,castX:.65,castY:1.08,unframedStrength:1.15,unframedLift:1.25,recessStrength:1.7,printShadowStrength:1.95,environmentAmount:.10},
          focusLayouts:{
            20:{fieldWidthIn:64},
            30:{fieldWidthIn:64},
            40:{fieldWidthIn:64}
          }
        }
      }
    },
    initialBackground:'gallery',initialView:'focus',hideMotionControl:true,
    previewPricing,
    /* Demo only. Replace with your store's authoritative price/variant adapter. */
    resolvePrice:async selection=>{
      const framed=selection.presentation==='Lined'||selection.presentation==='Crowned';
      const premium=framed&&['Midas Gold','Midnight Silver'].includes(selection.finish);
      return {amount:previewPricing.base+(framed?previewPricing.framed:0)+(premium?previewPricing.premiumFinish:0),currency:previewPricing.currency,test:true};
    },
    onClaim:null
  };
})();
